import { Box, Container, Input } from '@mui/material';
import { FC, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { useTypedSelector } from '../../../../store/store';
// import { CampaignTypes } from '../../../../api/models/rewards';
import { SignUpScreenStrings } from '../../../localization/en';
import { newFormatPhoneNumber } from '../../../../services/utilities';
import { useTrackEvent } from '../../../hooks/useTrackEvent';
import { EventNames } from '../../../constants/constants';

export const BottomPercent = '40%';

interface UserInfoBlockProps {
  onClick: (email?: string) => void;
}
const useStyles = makeStyles(() => {
  return {
    Container: {
      // maxWidth: '540px',
      width: '100%',
      // left: '50%',
      paddingLeft: 0,
      paddingRight: 0,
      // background: '#fff',
      // height: 'var(--app-height)',
      // minHeight: '550px',
    },
    wrapper: {
      backdropFilter: 'blur(10px)',
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      border: '1px solid #2D11AD',
      // borderRadius: '12px',
      // padding: '14px',
    },
    Button: {
      color: '#2D11AD',
      borderColor: '#2D11AD',
      width: '152px',
    },
    Question: {
      color: '#475467',
      fontSize: '18px',
      margin: '30px 0px',
      //   width: '75%',
    },
    formLabel: {
      color: '#475467',
      fontSize: '18px',
      fontWeight: 400,
      margin: '16px 8px',
    },
    AuthSubmitBtn: () => ({
      marginTop: '12px',
      backgroundColor: '#2D11AD',
      color: '#fff',
      width: '100%',
      height: '12.2vw',
      // maxWidth: '442px',
      maxHeight: '52px',
      fontSize: 'clamp(16px, 4.4vw, 24px)',
      fontWeight: 400,
      '&:hover': {
        backgroundColor: '#2D11AD',
        boxShadow: 'unset',
      },
      '&:disabled': {
        backgroundColor: '#ccc' /* Light gray */,
        color: '#666' /* Darker text */,
        cursor: 'not-allowed',
        opacity: '0.6',
      },
    }),
    input: {
      width: '100%',
      height: '12.2vw',
      // maxWidth: '442px',
      maxHeight: '52px',
      border: '1px solid',
      borderRadius: '8px',
      borderColor: '#D0D5DD',
      marginBottom: '10px',
      background: 'white',
      paddingLeft: '12px',
      color: '#2D11AD',
      // '& .MuiInput-input:-webkit-autofill, .MuiInput-input:-webkit-autofill:focus, .MuiInput-input:-webkit-autofill:hover':
      //   {
      //     WebkitTextFillColor: '#2D11AD',
      //     fontSize: 'clamp(16px, 4.4vw, 24px)',
      //   },
      '& input': {
        color: '#2D11AD !important',
        fontSize: 'clamp(16px, 4.4vw, 24px)',
        '&::placeholder': {
          color: '#A9B3C8',
        },
      },
      '&.Mui-error': {
        borderColor: '#ED2E38',
      },
    },
  };
});
export const UserInfoBlock: FC<UserInfoBlockProps> = ({ onClick }) => {
  const classes = useStyles();
  // const { currentCampaign, primaryCampaign } = useTypedSelector((state) => state.rewards);
  const { firstName, lastName, phoneNumber } = useTypedSelector((state) => state.me);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  // const isCustomRewardCampaign = currentCampaign?.campaignType === CampaignTypes.CUSTOM_REWARD;
  // const isMonthlyGiveawayCampaign = currentCampaign?.campaignType === CampaignTypes.MONTHLY_GIVEAWAY;
  // const isNoRewardCampaign = currentCampaign?.campaignType === CampaignTypes.NO_REWARD;
  const { trackEvent } = useTrackEvent();

  const formatterNumber =
    phoneNumber.substring(0, 2) === '+1' ? newFormatPhoneNumber(phoneNumber, { showPlusOne: false }) : phoneNumber;

  // const emailRequired = currentCampaign ? !!currentCampaign?.emailRequired : !!primaryCampaign?.emailRequired;
  const emailRequired = false;
  const handleEmailChange = (e: { target: { value: string } }) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (!validateEmail(newEmail)) {
      setEmailError('Invalid email address');
    } else {
      setEmailError('');
    }
  };
  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleEmailBlur = async () => {
    validateEmail(email);
    handleBlur({ target: { value: email, name: 'email' } });
  };

  const handleBlur = (e: { target: { value: string; name: string } }) => {
    trackEvent({ action: EventNames.input_field_focus, name: e.target.name, value: e.target.value });
  };

  return (
    <Container
      sx={
        {
          // position: 'absolute',
          // zIndex: 2,
          // transform: `translateX(-50%)`,
          // marginTop: '-20px',
        }
      }
      className={classes.Container}
    >
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'flex-start'}
        flexDirection={'column'}
        padding="30px 30px"
        className={classes.wrapper}
        style={{ padding: '16px', borderRadius: '8px' }}
      >
        <>
          <p
            style={{
              fontWeight: '600',
              color: '#2D11AD',
              fontSize: 'clamp(13px,4.2vw,18px)',
              whiteSpace: 'nowrap',
              margin: '0px 10px 10px 5px',
              lineHeight: '24px',
            }}
          >
            {SignUpScreenStrings.GetCredit}
          </p>
          {/* <p style={{ fontWeight: '600', color: '#475467', fontSize: '18px', margin: '5px' }}>
            {'text'}
          </p> */}
        </>

        <Box display={'flex'} gap="10px">
          <Input
            className={classes.input}
            value={firstName}
            disableUnderline={true}
            name="firstName"
            placeholder={SignUpScreenStrings.First}
            onBlur={handleBlur}
            disabled
          />

          <Input
            className={classes.input}
            value={lastName}
            disableUnderline={true}
            name="lastName"
            placeholder={SignUpScreenStrings.Last}
            onBlur={handleBlur}
            disabled
          />
        </Box>
        <Input
          className={classes.input}
          value={formatterNumber}
          disableUnderline={true}
          name="phoneNumber"
          placeholder={SignUpScreenStrings.Last}
          style={{ width: '100%', marginBottom: emailRequired ? '10px' : 'unset' }}
          onBlur={handleBlur}
          disabled
        />
        {emailRequired && (
          <Input
            className={classes.input}
            value={email}
            onChange={handleEmailChange}
            disableUnderline={true}
            error={!!emailError}
            name="email"
            placeholder={'Enter an email'}
            onBlur={handleEmailBlur}
            style={{ width: '100%', marginBottom: 'unset' }}
          />
        )}
        <button
          className={classes.AuthSubmitBtn}
          style={{
            height: '52px',
            borderRadius: '12px',
            width: '100%',
          }}
          // variant="contained"
          // fullWidth
          disabled={emailRequired ? (email.length && !emailError.length ? false : true) : false}
          onClick={() => {
            onClick(email);
          }}
        >
          Next
        </button>
      </Box>
    </Container>
  );
};
